// extracted by css-extract-rspack-plugin
export default {"pagination":"SHb2514GIIajS4SC","hud":"pw51jFLx6CcRGejg"};